import { Box, CircularProgress, IconButton, Tab, Tabs } from "@mui/material"
import { useState } from "react"
import CustomDialog from "../../../components/layouts/common/CustomDialog"
import { CenteredBox } from "../../../components/layouts/OneViewBox"
import HearingDetails from "./HearingDetails"
import { useDispatch, useSelector } from "react-redux"
import BeneficiaryPersonalDeatils from "./BeneficiaryPersonalDeatils"
import { createFullName, titleCase } from "../../../utils/helper"
import fileDownload from "js-file-download"
import { callApiAction } from "../../../store/actions/commonAction"
import { Download } from "@mui/icons-material"
import { downloadBeneficiaryReport } from "../../../apis/beneficiary.api"
import BeneficiaryUpdateButton from "../components/BeneficiaryUpdateButton"
import SuggetstedProductDetails from "./SuggestedProductDetails"
import AudioGram from "../AudioGram"
import OtoScopDataUi from "../OtoScopeUi"

const DownloadReportComponent = ({ params }) => {
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(false)

  const onClick = () => {
    setLoading(true)
    dispatch(
      callApiAction(
        async () => await downloadBeneficiaryReport({ id: params._id }),
        (response) => {
          fileDownload(response, `${params.first_name} ${params.last_name}.pdf`)
          setLoading(false)
        },
        (err) => {
          console.log(err)
          setLoading(false)
        },
        true
      )
    )
  }

  if (loading) return <CircularProgress size={25} />

  return (
    <IconButton onClick={onClick}>
      <Download color="primary" />
    </IconButton>
  )
}

const DetailedViewMain = ({ data, loading, setData, modalKey, fetchFollowUps, followupLoading }) => {
  const { user } = useSelector((state) => state)
  const allowedModules = user.data.modules ?? []
  const [tab, setTab] = useState(0)

  const handleTabChange = (e, newVal) => setTab(newVal)

  return (
    <CustomDialog
      id={modalKey}
      loading={loading}
      title={`Beneficiary Details (${!loading
        ? titleCase(createFullName(data.first_name, data.last_name))
        : "Loading..."
        })`}
      closeText="Close"
    >
      {loading ? (
        <CenteredBox>
          <CircularProgress size={30} />
        </CenteredBox>
      ) : (
        <Box mt={2}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              background: "white",
              borderBottom: 1,
              borderColor: "divider",
              mb: 2,
              flexWrap: "wrap",
            }}
          >
            <Tabs
              sx={{
                flexGrow: 1,
                minHeight: "48px",
              }}
              scrollButtons
              allowScrollButtonsMobile
              value={tab}
              onChange={handleTabChange}
              variant="scrollable"
            >
              <Tab label="Beneficiary Details" value={0} />
              <Tab label="OtoScope Details" value={1} />
              <Tab label="AudioGram Details" value={2} />
            </Tabs>

            {/* <Box
                sx={{ display: "flex", alignItems: "center", gap: 1, pr: 1 }}
              >
                <BeneficiaryUpdateButton id={data?._id} type="icon" />
                {data && data["_id"] && (
                  <DownloadReportComponent params={data} />
                )}
              </Box> */}
          </Box>

          {tab === 0 && (
            <BeneficiaryPersonalDeatils data={data} setData={setData} />
          )}
          {tab === 1 && <Box p={2} ><OtoScopDataUi
            fields={data}

            isView={true}
          /></Box>}
          {tab === 2 && <AudioGram oscillaAudiogramState={data} />}
        </Box>
      )}
    </CustomDialog>
  );
}

export default DetailedViewMain
